var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadError
    ? _c(
        "contentBox",
        { attrs: { loading: !_vm.recLoaded } },
        [
          _vm.agent
            ? _c(
                "contentTitle",
                { attrs: { label: "USER ACCOUNT", close: "home" } },
                [
                  _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.agent.username))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.agent
            ? _c("contentBody", [
                _c(
                  "div",
                  { staticClass: "p-3" },
                  [
                    _vm.tab == "billing"
                      ? _c("billing", {
                          attrs: {
                            agent: _vm.agent,
                            planCurrent: _vm.planCurrent
                          }
                        })
                      : _vm.tab == "email"
                      ? _c("email", { attrs: { agent: _vm.agent } })
                      : _vm.tab == "password"
                      ? _c("password", { attrs: { agent: _vm.agent } })
                      : _vm.tab == "plan"
                      ? _c("plan", {
                          attrs: {
                            agent: _vm.agent,
                            planCurrent: _vm.planCurrent
                          }
                        })
                      : _vm.tab == "team"
                      ? _c("team", {
                          attrs: {
                            agent: _vm.agent,
                            planCurrent: _vm.planCurrent
                          }
                        })
                      : _c("overview", {
                          attrs: {
                            agent: _vm.agent,
                            planCurrent: _vm.planCurrent
                          }
                        })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dcb841b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dcb841b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agent/agent.vue
// module id = null
// module chunks = 